import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export default function DraggableDialog(props) {
   
   
    const handleClose = () => {
        props.setOpenDraggableDialog(false);
       
    };

    const handleCancelSubscription = () => {
        
        props.oncancel();
        props.setOpenDraggableDialog(false);
    }
    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Subscription cancellation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to cancel?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        No
                    </Button>
                    <Button onClick={handleCancelSubscription}>Yes</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
